<template>
  <div class="popup-content flex-between">
    <div class="popup-inner flex-center">
      <img src="@/assets/imgs/app.png" alt="" />
      <span>扫码下载客户端</span>
    </div>
    <div class="popup-inner flex-center">
      <img src="@/assets/imgs/wx.jpg" alt="" />
      <span>扫码进入小程序</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PhoneDirectPopup",
};
</script>

<style lang="less" scoped>
.popup-content {
  position: absolute;
  top: 100%;
  left: -180px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 18px 20px;
  min-width: 300px;
  z-index: 9999;
  margin-top: 35px;
  box-sizing: border-box;

  .popup-inner {
    font-family: MicrosoftYaHei;
    font-size: 13px;
    text-align: center;
    img {
      width: 120px;
      height: 120px;
      padding: 4px;
      border-radius: 10px;
      border: 1px solid #d5d5d5;
      margin-bottom:10px
    }
  }
}

.popup-content::after {
  content: "";
  position: absolute;
  top: -8px;
  right: 20px;
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-style: solid;
  border-color: transparent transparent #fff transparent;
  z-index: 1;
}

.popup-content::before {
  content: "";
  position: absolute;
  top: -9px;
  right: 20px;
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-style: solid;
  border-color: transparent transparent #e5e5e5 transparent;
  z-index: 0;
}
</style>
